export type Testimonial = {
  name: string;
  source: "Google" | "Infobel" | "MyHammer";
  rating: 5;
  date: string;
  text: string;
};

// Echte Bewertungen aus Google (9), Infobel (7) und MyHammer.
// Stand: Juni 2026. Bitte regelmäßig aktualisieren.
export const testimonials: Testimonial[] = [
  {
    name: "Claudia Fric",
    source: "Google",
    rating: 5,
    date: "vor 3 Monaten",
    text: "Danke, Danke, Danke. Ihr wart meine Retter in der Not. Unkompliziert, verlässlich, sauber und das trotz 450 kg Steinplatten über das Stiegenhaus in den dritten Stock. Auf der nach oben offenen Sternenskala gäbe es 100 Sterne ;-).",
  },
  {
    name: "Nicole Grill",
    source: "Google",
    rating: 5,
    date: "vor 3 Wochen",
    text: "Sehr zuverlässiges und freundliches Transportunternehmen. Alles wurde pünktlich und sorgfältig transportiert. Die Mitarbeiter waren hilfsbereit und haben schnell gearbeitet. Preis-Leistung passt auf jeden Fall. Klare Empfehlung!",
  },
  {
    name: "Marko Bartel",
    source: "Google",
    rating: 5,
    date: "vor 6 Monaten",
    text: "Termin war kurzfristig möglich, ist super schnell und professionell abgelaufen, alles top, kann man nur empfehlen!!",
  },
  {
    name: "Teresa Iz",
    source: "Google",
    rating: 5,
    date: "vor 2 Monaten",
    text: "Vielen vielen Dank! So flexibel, unkompliziert und verlässlich! 5 Sterne reichen für die Bewertung nicht aus. Wärmstens zu empfehlen!",
  },
  {
    name: "Alexandra E.",
    source: "Google",
    rating: 5,
    date: "vor 2 Monaten",
    text: "Absolut empfehlenswert!! Haben schnell einen Termin bekommen, alles hat bestens funktioniert – sehr, sehr zuverlässig, professionell und preiswert! Nochmals vielen Dank für eure Hilfe!!",
  },
  {
    name: "gallier87",
    source: "Google",
    rating: 5,
    date: "vor einem Jahr",
    text: "Unglaublich zuverlässig und kompetent. Wenn möglich, würde ich 10 Sterne+ vergeben. Top!!!",
  },
  {
    name: "Kunde",
    source: "MyHammer",
    rating: 5,
    date: "vor 2 Monaten",
    text: "I used this company for my move from Vienna to Bologna and everything went smoothly. The team was punctual, careful with my belongings, and delivered on time. Reliable and professional service.",
  },
  {
    name: "Kunde",
    source: "MyHammer",
    rating: 5,
    date: "vor 2 Monaten",
    text: "Ich war wirklich rundum zufrieden. Alles wurde super zuverlässig organisiert und der gesamte Ablauf war absolut unkompliziert. Vielen Dank für die tolle Unterstützung, klare Empfehlung meinerseits!",
  },
];

// Aggregat für Schema.org – basiert auf echten Plattform-Zahlen.
export const reviewAggregate = {
  ratingValue: "5.0",
  reviewCount: 16, // 9 Google + 7 Infobel
  bestRating: "5",
  worstRating: "1",
};
